import { useEffect, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Stack, Tab } from '@mui/material';
import { useAuth } from 'providers/auth-provider/AuthJwtProvider';
import ModuleAccess from '../moduleAccess';
import PayrollRecords from '../salaryRecords';
import UserAttendance from '../userAttendance';
import CandidateDocuments from './CandidateDocuments';

const CandidateDetailsMain = ({ state, profile = false }) => {
  const { sessionUser } = useAuth();
  const [value, setValue] = useState('1');
  const [myProfile, setMyProfile] = useState(true);

  useEffect(() => {
    setMyProfile(sessionUser._id == state._id);
  }, [sessionUser, state]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack direction="column" sx={{ height: 1 }}>
      <TabContext value={value}>
        <TabList onChange={handleChange}>
          <Tab label="Documents" value="1" />

          <Tab label="Attendance" value="2" disabled={!profile} />
          <Tab label="Module Access" value="3" disabled={!profile || myProfile} />
          <Tab label="Salary Records" value="4" />
        </TabList>
        <TabPanel sx={{ p: 0, pt: 5, height: 1 }} value="1">
          <CandidateDocuments state={state} />
        </TabPanel>
        {profile && (
          <TabPanel sx={{ p: 0, pt: 5, height: 1 }} value="2">
            <UserAttendance state={state} />
          </TabPanel>
        )}

        {profile && (
          <TabPanel sx={{ p: 0, pt: 5, height: 1 }} value="3">
            <ModuleAccess state={state} />
          </TabPanel>
        )}
        <TabPanel sx={{ p: 0, pt: 5, height: 1 }} value="4">
          <PayrollRecords state={state} />
        </TabPanel>
      </TabContext>
    </Stack>
  );
};

export default CandidateDetailsMain;
